/**
 * Returns true if string is provided
 *
 * @param {string} string - The string value to check
 * @return {boolean} True if string and not empty string with white space.  False otherwise.
 */
export function isString(string) {
    let isValidString = false;
    if (typeof string === 'string') {
        const removeWhiteSpace = string.trim();
        isValidString = removeWhiteSpace.length > 0;
    }
    return  isValidString;
}
